import {
  addTenantTranslationMemoryResource,
  getTenantTranslationMemoryResources,
  removeTenantTranslationMemoryResource,
  updateTenantTranslationMemoryResource,
} from '../../services/api-calls';

import resourceConfigurationHoc from '../common/resourceConfigurationHoc';
import { AWS_ROLE_ARN_REGEX } from '../../../../global/constants';
import { tenantAwsAccountsSubject$ } from '../../../../global/api-calls';
import { take } from 'rxjs/operators';

const TranslationMemory = resourceConfigurationHoc(
  'Translation Memory',
  {
    uuid: {
      header: 'ID',
      type: 'text',
      width: 500,
    },
    awsAccountId: {
      header: 'Aws Account Id',
      type: 'editableInput',
      validationHandler: async input => {
        return tenantAwsAccountsSubject$
          .pipe(take(1))
          .toPromise()
          .then(awsAccounts => {
            const awsAccountIds = new Set(
              awsAccounts.map((awsAccount, index) => {
                return awsAccount.awsAccountId;
              })
            );
            if (!awsAccountIds.has(input)) {
              throw Error(`must be one of registered accounts [${Array.from(awsAccountIds.values()).join(', ')}]`);
            }
          });
      },
    },
    tmTableName: {
      header: 'TM Table Name',
      type: 'editableInput',
      validationHandler: async input => {
        if (!input) {
          throw Error('cannot be empty');
        }
      },
    },
    tmIdentifier: {
      header: 'TM Identifier',
      type: 'editableInput',
      validationHandler: async input => {
        if (!input) {
          throw Error('cannot be empty');
        }
      },
    },
    roleArn: {
      header: 'Role Arn',
      type: 'editableInput',
      validationHandler: async input => {
        if (!AWS_ROLE_ARN_REGEX.test(input)) {
          throw Error('must match valid AWS role ARN');
        }
      },
    },
  },
  addTenantTranslationMemoryResource,
  updateTenantTranslationMemoryResource,
  removeTenantTranslationMemoryResource,
  getTenantTranslationMemoryResources
);

export default TranslationMemory;
